/**
 * @author: Khanh Le <quockhanhle1997@gmail.com>
 * @date: 26/07/2023
 */
import vue from 'vue';
import Vue from "vue";

class UserPolicyService {
    async checkUserPolicy() {
        try {
            return await Vue.axios.get("/user/check-policy");
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async updateUserPolicy(data = {}) {
        try {
            return await Vue.axios.post("/user/update-policy",data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
const userPolicyService = new UserPolicyService();
export default userPolicyService;


// WEBPACK FOOTER //
// ./src/core/services/userPolicyService.js